import React from "react";
import { Outlet } from "react-router-dom";
import Header from "../Header";
import Footer from "../Footer";

const Layout = (props) => {
  return (
    <main style={{ maxWidth: "62.5rem", margin: '0 auto' }}>
      <Header />
      <Outlet />
      <Footer />
    </main>
  );
};

export default Layout;
